import { AxiosError } from 'axios';

/**
 * Checks if axios error contains a specified string
 * @param state the error catched
 * @param words the string to test
 */
export const isErrorContaining = (error: AxiosError, words: string): boolean => {
  return error.response?.data?.message?.includes(words) || error?.response?.data?.detail?.includes(words);
};

/**
 * Checks if axios error contains a specified key
 * @param state the error catched
 * @param key the string to test
 */
export const isErrorContainingKey = (error: AxiosError, key: string): boolean => {
  return error?.response?.data?.errorKey?.includes(key);
};

/**
 * Get params from error message
 * @param error the error message
 */
export const getParamsFromErrorMessage = (error: AxiosError): string[] => {
  const message = error?.response?.data?.message;
  const matches = message?.matchAll(/\{(.*?)\}/g);

  return (matches && Array.from(matches, (x) => x[1])) || null;
};
